import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import API_BASE_URL from "../config/api";

function Login() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    login: "",
    password: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  /* ================= GOOGLE INIT ================= */
  useEffect(() => {
    if (window.google && document.getElementById("googleLoginDiv")) {
      window.google.accounts.id.initialize({
        client_id:
          "956569074304-5scv2ocl4pdut7659l9msuio6li95e0d.apps.googleusercontent.com",
        callback: handleGoogleLogin,
      });

      window.google.accounts.id.renderButton(
        document.getElementById("googleLoginDiv"),
        {
          theme: "outline",
          size: "large",
          width: 500, 
          text: "signin_with",
        }
      );
    }
  }, []);

  /* ================= GOOGLE LOGIN ================= */
  const handleGoogleLogin = async (response) => {
    try {
      const res = await axios.post(
        `${API_BASE_URL}/login.php`,
        { credential: response.credential },
        { headers: { "Content-Type": "application/json" } }
      );

     if (res.data.success) {

  sessionStorage.setItem("user", JSON.stringify(res.data.user));

  Swal.fire({
    icon: "success",
    title: "Login Successful",
    showConfirmButton: false,
    timer: 1200
  });

 sessionStorage.setItem("verifyNo", res.data.user.is_verify_mobile);
    const isVerified = String(res.data.user.is_verify_mobile) === "Y";
//console.log("User Mobile Verified:", isVerified);
if (isVerified) {
    navigate("/studentdashboard");
} else {
    navigate("/complete-profile");
}


} else {
        Swal.fire({
          icon: "error",
          title: "Login Failed",
          text: res.data.message || "Account not found",
        });
      }
    } catch {
      Swal.fire({
        icon: "error",
        title: "Server Error",
        text: "Something went wrong",
      });
    }
  };

  /* ================= HANDLE CHANGE ================= */
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  /* ================= VALIDATION ================= */
  const validate = () => {
    const newErrors = {};

    if (!formData.login.trim())
      newErrors.login = "Email or Mobile number is required";

    if (!formData.password.trim())
      newErrors.password = "Password is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /* ================= NORMAL LOGIN ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);

    try {
      const form = new FormData();
      form.append("login", formData.login);
      form.append("password", formData.password);

      const res = await axios.post(
        `${API_BASE_URL}/login.php`,
        form
      );

      if (res.data.success) {
        await Swal.fire({
          icon: "success",
          title: "Login Successful",
          showConfirmButton: false,
          timer: 1200
        });

        sessionStorage.setItem("user", JSON.stringify(res.data.user));
        sessionStorage.setItem("verifyNo", res.data.user.is_verify_mobile);
    const isVerified = String(res.data.user.is_verify_mobile);
   // alert(isVerified);
    //console.log("User Mobile Verified:", isVerified);
if (isVerified === "Y") {
    navigate("/studentdashboard");
} else {
    navigate("/complete-profile");
}
      } else {
        Swal.fire({
          icon: "error",
          title: "Login Failed",
          text: res.data.message || "Invalid credentials",
        });
      }
    } catch {
      Swal.fire({
        icon: "error",
        title: "Server Error",
        text: "Something went wrong",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="gray-simple">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6 col-lg-7 col-md-9 col-sm-12">
            <div className="card rounded-4 shadow-lg mt-5">
              <div className="card-body p-4 p-md-5">

                <div className="text-center mb-4">
                  <h3 className="fw-bold" style={{ color: "#176fb0" }}>
                    Sign in
                  </h3>
                  <p className="text-muted">
                   Start your aviation journey 
                  </p>
                </div>

                <form onSubmit={handleSubmit} noValidate>
                  <div className="row g-4">

                    {/* LOGIN FIELD */}
                    <div className="col-12">
                      <label className="form-label fw-semibold">
                        Email / Mobile Number <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        name="login"
                        value={formData.login}
                        onChange={handleChange}
                        className={`form-control ${errors.login ? "border-danger" : ""}`}
                      />
                      {errors.login && (
                        <small className="text-danger">{errors.login}</small>
                      )}
                    </div>

                    {/* PASSWORD */}
                    <div className="col-12">
                      <label className="form-label fw-semibold">
                        Password <span className="text-danger">*</span>
                      </label>
                      <input
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        className={`form-control ${errors.password ? "border-danger" : ""}`}
                      />
                      {errors.password && (
                        <small className="text-danger">{errors.password}</small>
                      )}
                    </div>
                      {/* FORGOT PASSWORD LINK */}
                    <div className="col-12 mt-2">
                      <Link to="/forgot-password" className=" float-end text-decoration-none">
                        Forgot Password?
                      </Link>
                    </div>
                    {/* LOGIN BUTTON */}
                    <div className="col-12">
                      <button
                        type="submit"
                        className="btn w-100 py-2 fw-semibold"
                        style={{
                          background: "linear-gradient(135deg,#176fb0,#0b4f86)",
                          color: "#fff",
                          borderRadius: "14px",
                        }}
                        disabled={loading}
                      >
                        {loading ? "Signing In..." : "Sign In"}
                      </button>
                    </div>

                    {/* DIVIDER */}
                    <div className="col-12 text-center my-3">
                      <div className="d-flex align-items-center">
                        <hr className="flex-grow-1" />
                        <span className="mx-2 text-muted">OR</span>
                        <hr className="flex-grow-1" />
                      </div>
                    </div>

                    {/* GOOGLE BUTTON */}
                    <div className="col-12">
                      <div id="googleLoginDiv" className="d-flex justify-content-center"></div>
                    </div>

                    {/* SIGNUP LINK */}
                    <div className="col-12 text-center mt-3">
                      <p className="mb-1 text-muted">Don’t have an account?</p>
                      <Link to="/signup" className="fw-bold text-decoration-none">
                        Create Account →
                      </Link>
                    </div>

                  </div>
                </form>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Login;
